import {weChatrequest} from '@/utils/request'

// 场站新增
export function gasStationAdd(data) {
    return weChatrequest({
        url: '/api/gas-station',
        method: 'post',
        data
    })
}
// 场站编辑
export function gasStationEdit(data) {
  return weChatrequest({
    url: '/api/gas-station',
    method: 'put',
    data
  })
}
//场站查询
export function lgasStationList(data) {
  return weChatrequest({
      url: '/api/gas-station/page',
      method: 'get',
      params: data
  })
} 
// 场站删除
export function deleteGasStation(id) {
  return weChatrequest({
    url: `/api/gas-station/${id}`,
    method: 'delete',
  })
}
// 获取场站视频
export function getStationVideos(id) {
  return weChatrequest({
    url: `/api/gas-station/${id}`,
    method: 'get'
  })
}